import styled from "styled-components";
import { Button, Tabs } from "antd";
import { DownOutlined } from "@ant-design/icons";

// ─── Tabs Container ───────────────────────────────────────────────────────────
// Sits directly under the shared PageHeader band. Must be styled — border,
// background, z-index, padding are visual tokens that cannot be expressed as
// AntD component props.

export const PageHeaderContainerStyled = styled.div`
  padding: 0 24px;
  border-bottom: 1px solid ${(p) => p.theme?.colors?.border ?? "#D8DAE5"};
  flex-shrink: 0;
  background: ${(p) => p.theme?.colors?.cardBg ?? p.theme?.colors?.white ?? "#ffffff"};
  position: relative;
  z-index: var(--z-header, 1000);
`;

// ─── Navigation Tabs ──────────────────────────────────────────────────────────
// AntD Tabs replaces the entire custom button tab row.
// styled only sets visual tokens (color, font) that AntD Tabs does not
// expose as direct props — all values reference theme tokens, no hardcoded hex.

export const NavTabsStyled = styled(Tabs)`
  && .ant-tabs-tab {
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.4px;
    padding: 8px 20px;
    margin: 0;
  }
  && .ant-tabs-tab + .ant-tabs-tab {
    margin: 0;
  }
  && .ant-tabs-ink-bar {
    background: ${(p) => p.theme?.colors?.primary ?? "#008080"};
  }
  && .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${(p) => p.theme?.colors?.primary ?? "#008080"};
    font-weight: 600;
  }
  && .ant-tabs-tab:hover .ant-tabs-tab-btn {
    color: ${(p) => p.theme?.colors?.primary ?? "#008080"};
  }
  && .ant-tabs-nav {
    margin: 0;
  }
  && .ant-tabs-nav::before {
    border: none;
  }
`;

// ─── Right Dropdown Trigger ───────────────────────────────────────────────────
// Sits in tabBarExtraContent — styled to visually match the tab items.
// AntD Button type="text" provides the base; styled adds the tab-matching font.

export const RightDropdownTriggerStyled = styled(Button).attrs({ type: "text" })`
  && {
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.4px;
    color: ${(p) => p.theme?.colors?.gray ?? "#565E70"};
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 20px;
    height: auto;
    border-radius: 0;
  }
  &&:hover {
    color: ${(p) => p.theme?.colors?.primary ?? "#008080"};
    background: transparent;
  }
`;

// ─── Dropdown Icon ────────────────────────────────────────────────────────────
// AntD icons have no built-in size prop — one styled component for this token.

export const NavTabDropdownIconStyled = styled(DownOutlined)`
  font-size: 11px;
`;
